// extracted by mini-css-extract-plugin
export default {"price":"Price_price__UpyvE","large":"Price_large__-nN1Q","unitPrice":"Price_unitPrice__qcFDi"};